<ng-template cellTemplate let-dataItem="dataItem">
    <span (click)="$event['ignoreClickOutside'] = true">{{getDescription(dataItem)}}</span>
</ng-template>
<ng-template editTemplate let-dataItem="dataItem" let-columnIndex="columnIndex" let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <wbo-inventory-stock-size-single-select-edit-control #editControl (focussed)="columnFocusHandler($event, columnIndex)"
                                                         [elementId]="elementId"
                                                         [formControl]="formGroup.get(valueField)"
                                                         [placeholder]="getPlaceholder(dataItem)"
                                                         [inventoryId]="dataItem | property : inventoryIdField"
                                                         [objectValue]="formGroup.get(field)">
    </wbo-inventory-stock-size-single-select-edit-control>
</ng-template>
